// src/pages/business/Memberships/details/index.jsx
import { useCallback, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Loading from '@/widgets/Loading.jsx'
import useMembershipDetails from '../list/hooks/useMembershipDetails'
import MembershipInfoCard from './MembershipInfoCard'
import ConsumptionPanel from './ConsumptionPanel'

export default function MembershipDetails() {
	const { id } = useParams()
	const navigate = useNavigate()

	const { loading, error, membership, productsLoading, products, handleDelete, handleConsume } = useMembershipDetails( id,navigate )

	// Derive values early; hooks must be unconditional
	const isExpired = useMemo(() => String(membership?.status || '').toLowerCase() === 'expired', [membership?.status])
	const remainingUsage = useMemo(() => Number(membership?.remainingUsage ?? 0) || 0, [membership?.remainingUsage])
	const history = useMemo(
		() => (Array.isArray(membership?.consumptionDates) ? membership.consumptionDates : []),
		[membership?.consumptionDates]
	)

	// Stable edit handler
	const handleEdit = useCallback(() => {
		const mid = membership?._id
		if (!mid) return
		navigate(`/memberships/edit/${mid}`)
	}, [navigate, membership?._id])

	// Early returns after hooks
	if (loading) return <Loading />
	if (error) return <div className="min-h-screen flex items-center justify-center">Error: {String(error)}</div>
	if (!membership) return <div className="min-h-screen flex items-center justify-center">Not found</div>

	return (
		<div className="w-full grid grid-cols-1 gap-4 xl:gap-8 lg:grid-cols-2 xl:grid-cols-3">
			<div className="flex lg:col-span-1">
				<MembershipInfoCard membership={membership} onEdit={handleEdit} onDelete={handleDelete} />
			</div>

			<div className="flex flex-col lg:col-span-1 xl:col-span-2">
				<ConsumptionPanel
					membershipId={membership._id}
					remainingUsage={remainingUsage}
					products={products}
					history={history}
					productsLoading={productsLoading}
					onConsume={handleConsume}
					disabled={isExpired}
				/>
			</div>
		</div>
	)
}
